import React from "react";

/**
 * NotificationSkeleton Component
 *
 * Loading skeleton for notification items
 * Provides visual feedback while notifications are loading
 */
const NotificationSkeleton = ({ count = 3 }) => {
  return (
    <div className="notification-skeleton-container">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="notification-skeleton-item p-4 border-b border-gray-200 animate-pulse"
        >
          <div className="flex items-start space-x-3">
            {/* Avatar skeleton */}
            <div className="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0"></div>

            <div className="flex-1 space-y-2">
              {/* Name and message skeleton */}
              <div className="space-y-1">
                <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                <div className="h-3 bg-gray-200 rounded w-3/4"></div>
              </div>

              {/* Timestamp skeleton */}
              <div className="h-3 bg-gray-200 rounded w-1/6"></div>
            </div>

            {/* Action buttons skeleton */}
            <div className="flex space-x-2">
              <div className="w-6 h-6 bg-gray-300 rounded"></div>
              <div className="w-6 h-6 bg-gray-300 rounded"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationSkeleton;
